<ng-progress-bar
    [speed]="speed"
    [ease]="ease"
    [meteor]="meteor"
    [spinner]="spinner"
    [spinnerPosition]="spinnerPosition"
    [direction]="direction"
    [color]="color"
    [thick]="thick"
></ng-progress-bar>